import { BaseFilterProps, Filter, FilterData } from "@/components/filter/_types";
import { FilterComponent } from "@/components/filter/base-filter";
import { getDunningBlockReasonOptions } from "@/modules/fia/open-position/positions/_helpers/dunning-block-reasons";
import i18next from "i18next";
import { JSX } from "react";

export class OpenPositionDunningReasonFilter extends Filter<Record<string, never>, Record<string, never>> {
  readonly id = "dunningBlockReason";
  readonly labelSingular = "fia:FilterDunningReason";
  readonly labelPlural = "fia:FilterDunningReason";
  readonly placeholder = "fia:FilterDunningReason";
  readonly searchPlaceholder = "common:Search";
  readonly emptyText = "fia:NoOptionFound";
  body = {};
  parameters = {};

  getData(): FilterData {
    return {
      options: getDunningBlockReasonOptions((key) => i18next.t(key), i18next.language),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): JSX.Element {
    return <FilterComponent filter={this} {...props} />;
  }
}
